{
  "instances": {
    "loggers": {
      "label": "Loggers",
      "application": "Application",
      "filter": {
        "class_only": "class uniquement",
        "configured": "configuré"
      },
      "instance": "Instance",
      "new": "Nouveau",
      "no_loggers_found": "Aucun loggers trouvé.",
      "unset": "Réinitialiser",
      "setting_loglevel_failed": "Echec de la modification d'état du {logger} vers {loglevel}."
    }
  }
}
